import styled from 'styled-components'
import { Theme } from 'styles/Themes'
import { IMaskInput } from 'react-imask'

interface IStyleProps {
  rounded?: boolean
  small?: boolean
  xsmall?: boolean
  xxsmall?: boolean
  medium?: boolean
  large?: boolean
  icon?: boolean
  error?: string
  smallPad?: boolean
  disabled?: boolean
  resumeCard?: boolean
  empty?: boolean
}

export const Span = styled.span`
  position: absolute;
  left: 0px;
  top: -9px;
  z-index: 2;
  color: black;
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  height: 20px;

  padding: 2px 6px;
  border-radius: 10px;

  background: ${Theme.pallete.SECONDARY};
`

export const MaskedInput = styled(IMaskInput)`
  position: ${(props: IStyleProps) => (props.icon ? 'relative' : 'inherit')};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  height: 40px;
  width: ${(props: IStyleProps) => {
    if (props.xxsmall) return '90px'
    if (props.xsmall) return '112px'
    if (props.small) return '120px'
    if (props.medium) return '140px'
    if (props.large) return '160px'
    return '252px'
  }};

  max-width: ${(props: IStyleProps) => {
    if (props.xxsmall) return '90px'
    if (props.xsmall) return '112px'
    if (props.small) return '120px'
    if (props.medium) return '140px'
    if (props.large) return '160px'
    return '252px'
  }};

  padding: 16px 0px 16px 16px;
  margin-left: 0.5px;

  &:hover {
    background: #ffffff;
    /* background: ${(props: IStyleProps) =>
      props.error ? '#ff0000' : '#ffffff'}; */
  }

  box-sizing: border-box;
  border: ${(props: IStyleProps) =>
    props.error ? '1px solid #f60665' : '1px solid #cccccc'};
  border-radius: ${(props: IStyleProps) => (props.rounded ? '30px' : '5px')};
  background: #ffffff;

  &:focus {
    &::placeholder {
      color: transparent;
      opacity: 0;
    }
  }

  &:disabled {
    &::placeholder {
      color: #808080;
    }
    background: lightGray;
    border: 0;
  }

  @media only screen and (min-width: 1441px) {
    padding: 18px 0px 18px 18px;
    height: 45px;
    width: ${(props: IStyleProps) => {
      if (props.xxsmall) return '90px'
      if (props.xsmall) return '126px'
      if (props.small) return '135px'
      if (props.large) return '180px'
      return '284px'
    }};

    max-width: ${(props: IStyleProps) => {
      if (props.xxsmall) return '90px'
      if (props.xsmall) return '126px'
      if (props.small) return '135px'
      if (props.large) return '180px'
      return '284px'
    }};
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .asterisco {
    color: #f60665;
    margin-left: 10px;
  }
`

export const InputIcon = styled.img`
  width: ${(props: { icon: string }) => {
    if (props.icon === 'password') return '16px'
    return '20px'
  }};

  height: ${(props: { icon: string }) => {
    if (props.icon === 'password') return '16px'
    return '20px'
  }};

  filter: invert(48%) sepia(5%) saturate(92%) hue-rotate(98deg) brightness(93%)
    contrast(97%);

  position: absolute;
  right: 25px;
  top: 17px;
`

export const InputError = styled.div`
  position: absolute;
  bottom: -3px;
  transform: translateY(100%);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: start;
  width: ${(props: IStyleProps) => {
    if (props.xxsmall) return '90px'
    if (props.xsmall) return '112px'
    if (props.small) return '120px'
    if (props.large) return '160px'
    return '252px'
  }};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #d61212;
`

export const Loading = styled.div<{ loading: boolean | undefined }>`
  pointer-events: none;
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: ${(props) => (props.loading ? 'flex' : 'none')};
  .loading-img {
    width: 20px;
    @keyframes load {
      to {
        transform: rotate(360deg);
      }
    }
    animation: load 2s infinite linear;
  }
`
